export interface PromiseLifecycle {
  alive: boolean;
}

export function promiseLifecycle<T>(
  lifecycle: PromiseLifecycle,
  promise: Promise<T>,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    promise.then(
      (value) => {
        if (lifecycle.alive) {
          resolve(value);
        }
      },
      (value) => {
        if (lifecycle.alive) {
          reject(value);
        }
      },
    );
  });
}
